import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { FiPrinter } from 'react-icons/fi';
import Modal from '../../../components/Modal';
import Button from '../../../components/Button';
import './style.css';

export default function QRCodeModal({ isOpen, onClose, round }) {
  // Se não estiver aberto ou não tiver ronda selecionada, não renderiza nada
  if (!isOpen || !round) return null;

  const handlePrint = () => {
    window.print();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`QR Codes - ${round.name}`}
      size="lg"
    >
      <div className="qrcode-modal-content">
        {/* Cabeçalho visível apenas na impressão */}
        <div className="qrcode-print-header">
          <h2>{round.name}</h2>
          <p>Lista de QR Codes para Pontos de Ronda</p>
        </div>

        <div className="qrcode-grid">
          {round.points && round.points.length > 0 ? (
            round.points.map((point, index) => (
              <div key={point.id || index} className="qrcode-card">
                <div className="qrcode-card-border">
                  <h3 className="qrcode-title">{point.name}</h3>
                  <div className="qrcode-wrapper">
                    <QRCodeCanvas 
                      value={point.id ? String(point.id) : `point-${index}`} 
                      size={140}
                      level={"H"}
                      includeMargin={true}
                    />
                  </div>
                  <span className="qrcode-id">ID: {point.id || '-'}</span>
                </div>
              </div>
            ))
          ) : (
            <div className="no-points-message">
              Nenhum ponto configurado para esta ronda.
            </div>
          )}
        </div>

        <div className="qrcode-modal-actions">
          <Button 
            type="button" 
            variant="ghost" 
            onClick={onClose}
          >
            Fechar
          </Button>
          <Button 
            type="button" 
            onClick={handlePrint}
            startIcon={<FiPrinter />}
          >
            Imprimir Lista
          </Button>
        </div>
      </div>
    </Modal>
  );
}
